import { render } from "./AddCategorieArticlePage.vue?vue&type=template&id=2da9cd90&ts=true"
import script from "./AddCategorieArticlePage.vue?vue&type=script&lang=ts"
export * from "./AddCategorieArticlePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__